import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

interface Chat {
  id: string;
  contactId: string;
  contactName: string;
  contactAvatar?: string;
  lastMessage?: string;
  lastMessageTime?: Date;
  unreadCount?: number;
  isOnline?: boolean;
}

interface ChatListItemProps {
  chat: Chat;
  onClick: () => void;
}

export function ChatListItem({ chat, onClick }: ChatListItemProps) {
  return (
    <div
      onClick={onClick}
      className="flex items-center space-x-3 p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-700 relative"
    >
      <div className="relative">
        <Avatar className="h-12 w-12">
          <AvatarImage src={chat.contactAvatar} />
          <AvatarFallback>{chat.contactName.charAt(0)}</AvatarFallback>
        </Avatar>
        {chat.isOnline && (
          <div className="absolute bottom-0 right-0 h-3 w-3 bg-green-500 border-2 border-white rounded-full"></div>
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white truncate">
            {chat.contactName}
          </h3>
          {chat.lastMessageTime && (
            <span className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap ml-2">
              {format(chat.lastMessageTime, 'HH:mm', { locale: es })}
            </span>
          )}
        </div>

        {chat.lastMessage && (
          <p className="text-sm text-gray-600 dark:text-gray-300 truncate">
            {chat.lastMessage}
          </p>
        )}
      </div>

      {chat.unreadCount && chat.unreadCount > 0 && (
        <Badge variant="destructive" className="min-w-[20px] h-5 text-xs px-1.5">
          {chat.unreadCount > 99 ? '99+' : chat.unreadCount}
        </Badge>
      )}
    </div>
  );
}